module.exports = __webpack_public_path__ + "8f3f071ef01577486b4e6851fcc8c64e.png";